import * as React from "react";
import Login from "../../modules/Login";

export default (props) => <Login {...props} />;
